<template>
  <v-card :loading="loading" tile flat>
    <v-card-title>Email Verification</v-card-title>
    <v-alert border="bottom" colored-border :type="alertType" v-if="message">
      <span class="body-1">{{ message }}</span>
    </v-alert>
  </v-card>
</template>
<script>
import get from 'lodash/get';

export default {
  mounted() {
    const url = this.$route.query.verifyUrl;

    if (!url) {
      return this.setError('Invalid verification url');
    }

    this.loading = true;

    this.$http
      .post(url)
      .then(response => {
        this.alertType = 'success';
        this.message = response.message;
      })
      .catch(({ response }) => {
        const error = get(
          response,
          'data.message',
          get(response, 'message', 'Something went wrong'),
        );
        this.setError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  data() {
    return {
      loading: false,
      message: null,
      alertType: 'success',
    };
  },
  methods: {
    setError(message) {
      this.alertType = 'error';
      this.message = message;
    },
  },
};
</script>
